import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";
import { OverviewStep } from "@common/components/overviewStepSection/OverviewStepSection.types";
import { LegalEntityStepTabProps } from "./LegalEntityStepTab";

export function useLegalEntityStepTab(props: LegalEntityStepTabProps) {
    const url = `/LegalEntity/${props.legalEntityId}/overview/steps/${props.stepId}`;
    const { isLoading, data } = useDotLegalQuery<OverviewStep>(url);

    return {
        isLoading,
        data,
    };
}
